import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { AuthService } from '../../../services/auth/auth.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-authorize',
    templateUrl: './authorize.component.html',
    styleUrl: './authorize.component.scss',
    standalone: false
})
export class AuthorizeComponent {
  message: string = "Загрузка..."
  private code: string = "";
  constructor(private router: ActivatedRoute, private _authService: AuthServiceProxy,@Inject(PLATFORM_ID) private platformId: Object, private authService: AuthService) {}
  ngOnInit() {
    this.router.queryParams.subscribe((params) => {
      if (!params.code) {
        this.message = "Ошибка авторизации. Попробуйте еще раз."
      } else {
        this.message = "Загрузка...";
        this.code = params.code;
        if (isPlatformBrowser(this.platformId)) {
          this.authorize();
        }
      }
    })
  }
  authorize() {
    this.message = "Авторизация.. Пожалуйста, подождите."
    this._authService.authorize(this.code).subscribe((res) => {
      if (res) {
        this.message = "Авторизация прошла успешно. Загрузка..."
        localStorage.setItem("access_token", res.accessToken);
        location.href = "/dashboard";
      }
    }, error => {
      this.message = error.message;
    })
  }
}
